import { useEffect, useState } from 'react'

import { apiFetch } from '../../auth/apiClient'

// Inline images point at authenticated API endpoints; a plain <img> tag
// cannot send the bearer token, so the bytes arrive via fetch + blob URL.
export function AuthedImage({ src, alt }: { src: string; alt: string }) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    let active = true
    let createdUrl: string | null = null
    apiFetch(src)
      .then((response) => {
        if (!response.ok) throw new Error('Could not load attachment')
        return response.blob()
      })
      .then((blob) => {
        if (!active) return
        createdUrl = URL.createObjectURL(blob)
        setObjectUrl(createdUrl)
      })
      .catch(() => undefined)
    return () => {
      active = false
      if (createdUrl) URL.revokeObjectURL(createdUrl)
    }
  }, [src])

  return objectUrl ? <img src={objectUrl} alt={alt} /> : <span>{alt || 'Immagine non disponibile'}</span>
}
